module.exports = __webpack_public_path__ + "static/img/btn.0746117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd108/btn.png
// module id = tzO6
// module chunks = 1